import { Navigate, Outlet } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { GetUserProfile } from '../../services/User'

export const PrivateRoutes = () => {
    let content = <Outlet />

    useQuery(['userProfile'], () => GetUserProfile(), {
        retry: false,
        onError: () => {
            content = (
                <Navigate
                    to={`/login${
                        window.location.pathname !== '/'
                            ? `?redirectSuccess=${window.location.pathname}${window.location.search}`
                            : ''
                    }`}
                />
            )
        },
        staleTime: 60 * 60000
    })

    return content
}
